import { useCallback, useContext, useState } from 'react';

import { VizContext, HoverState, SelectedState, VizContextOutputType } from './VizContextProvider';

// This hook provides the synchronized hover and selected states across charts.
// If the VizContextProvider is not provided in the hierarchy or context value from provider is null,
// component local state will be output by this hook
export const useVizContext = (): VizContextOutputType => {
    const [syncedHoverValue, setSyncedHoverValue] = useState<HoverState>();
    const [syncedSelectedValue, setSyncedSelectedValue] = useState<SelectedState>();
    const clearSharedState = useCallback(() => {
        setSyncedHoverValue(undefined);
        setSyncedSelectedValue(undefined);
    }, []);

    const vizSyncContext = useContext(VizContext);

    if (vizSyncContext !== null) {
        return { ...vizSyncContext, hasProvider: true };
    }
    return {
        clearSharedState,
        syncedHoverValue,
        setSyncedHoverValue,
        syncedSelectedValue,
        setSyncedSelectedValue,
        hasProvider: false,
    };
};
